require('./permissionsEditor.i18n.json');
require('./permissionsEditor.tpl.html');
require('./permissionsModel.js');
require('./permissionsRepository.js');
require('./header/permissionsEditorHeaderComponent.js');

/*@ngInject*/
const PermissionsEditorController = function ($rootScope, $scope, $stateParams, authorizationConstants, configurationConstant, currentUserModel, localization, permissionsModel, permissionsRepository, userType, formatUtil) {

    $scope.viewModel = {
        userType: parseInt($stateParams.userType),
        permissions: null,
        requestParams: {},
        filteredAuthorizations: [],
        placeholder: 'Search',
        isGridEmpty: false,
        isLoading: true,
        hasManagePermission: false

    };

    function init() {
        var userType = $scope.viewModel.userType;
        permissionsRepository.loadPermissionsByUserType(userType).then(function (permissions) {
            permissionsModel.setPermissions(permissions);
            $scope.viewModel.permissions = permissions;
            $scope.filterAuthorizations();
        });
        localization.getTranslationByKey('permissionsEditor').then(function (translations) {
            $scope.viewModel.placeholder = _.get(translations, 'placeholder');
        });
    }


    $scope.handleSelect = function () {
        permissionsModel.setPermissions($scope.viewModel.permissions);
        $rootScope.$broadcast(configurationConstant.event.PERMISSIONS_UPDATED);
    };

    $scope.filterAuthorizations = function () {
        var filterText = _.toLower($scope.viewModel.filterText),
            authorizations = $scope.viewModel.permissions.authorizationSummaries;
        $scope.viewModel.isLoading = true;
        $scope.viewModel.filteredAuthorizations = _.filter(authorizations, function (authorization) {
            var description = _.toLower(authorization.description);
            $scope.viewModel.isLoading = false;
            return _.isEmpty(filterText) || _.includes(description, filterText);
        });
        $scope.viewModel.isGridEmpty = _.isEmpty($scope.viewModel.filteredAuthorizations);
    };

    $scope.getPermissionCheckboxClass = function (name, assignedAuthorization) {
        var permissionName = name.replace(/ /g, '');
        return permissionName + '_' + assignedAuthorization.roleDescription + ' ' + assignedAuthorization.authorizationAssigned;
    };

    $scope.hasManagePermission = function (hasPermission) {
        $scope.viewModel.hasManagePermission = hasPermission;
    };

    $scope.getSelector = function (roleName) {
        return formatUtil.formatAsSelector(roleName);
    };

    init();
};

angular.module('ums.configuration')
    .controller('permissionsEditorController', PermissionsEditorController);
